<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-icon.png" alt height="22" style="width: 90%" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.png" alt height="15" style="width: 90%"/>
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-icon.png" alt height="50" style="width: 90%"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.png" alt height="42" style="width: 90%"/>
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item"
          id="vertical-menu-btn"
          @click="toggleMenu()"
        >
          <i class="mdi mdi-menu"></i>
        </button>

        <div class="d-none d-sm-block">
        </div>
      </div>
      <b-alert show="" variant="danger" v-if="!$store.getters.connected"> <i class="fas fa-sync"></i> Bağlantın koptu, lütfen sayfayı yeniden yükle. </b-alert>
      <div class="d-flex">


        <div class="dropdown d-none d-lg-inline-block">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
            <i class="mdi mdi-fullscreen"></i>
          </button>
        </div>

        <b-dropdown class="d-inline-block" right toggle-class="header-item" variant="white">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/avatar-6.jpg"
              alt="Header Avatar"
            />
          </template>
          <a v-b-modal.changePasswordModal class="dropdown-item d-block" href="#">
            <i class="mdi mdi-settings font-size-17 align-middle mr-1"></i> Şifre Değiştir
          </a>
          <div class="dropdown-divider"></div>
          <router-link :to="{path: '/logout'}" class="dropdown-item text-danger" href="/logout">
            <i class="bx bx-power-off font-size-17 align-middle mr-1 text-danger"></i> Çıkış Yap
          </router-link>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
<script>

/**
 * Topbar component
 */
export default {
  data() {
    return {};
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  }
};
</script>

